<div class="navigation-progress {{theme}}-theme">
    <div class="container-fluid">
        <div class="row">
            <div  class="col col-lg-1"  >
                <a *ngIf="currentSection != 1" class="btn px-0"   src="#" (click)="onGoBack()">go back</a>
            </div>
            <div class="col text-center border-left border-right">
                {{currentSection}}/{{sectionsTotal}}
            </div>
            <div class="col col-lg-1">
                <a [ngClass]="{'btn px-0':true, 'disabled': !isValidSection }"
                    src="#" (click)="onContinue()" 
                [innerHtml]="sectionType == 4 ? 'finish' : 'continue' "></a>
            </div>
        </div>
    </div>
    <div class="position-relative">
        <div class="full-progress-bar"></div>
        <div class="progress-bar" [ngStyle]="{'width.%': (currentSection * 100 )/sectionsTotal}" ></div>
    </div>
    
</div>